import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
    Box
} from '@mui/material';

type ConfirmDialogProps = {
    open: boolean;
    title?: string;
    content?: React.ReactNode;
    onClose: () => void;
    onConfirm?: () => void;
    confirmText?: string;
    cancelText?: string;
    confirmColor?: 'primary' | 'error' | 'warning';
    icon?: React.ReactNode;
    showCancel?: boolean;
};

export default function ConfirmDialog({
                                         open,
                                         title = 'Hinweis',
                                         content,
                                         onClose,
                                         onConfirm,
                                         confirmText = 'Bestätigen',
                                         cancelText = 'Abbrechen',
                                         confirmColor = 'primary',
                                         icon,
                                         showCancel = true,
                                      }: ConfirmDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-content"
        >
            <DialogTitle id="confirm-dialog-title">
                <Box display="flex" alignItems="center" gap={1}>
                    {icon && <Box display="flex">{icon}</Box>}
                    <Typography variant="h6" component="span">{title}</Typography>
                </Box>
            </DialogTitle>

            <DialogContent>
                {typeof content === 'string' ? (
                    <DialogContentText id="confirm-dialog-content">
                        {content}
                    </DialogContentText>
                ) : (
                    content
                )}
            </DialogContent>

            <DialogActions>
                {showCancel && (
                    <Button onClick={onClose} variant="outlined">
                        {cancelText}
                    </Button>
                )}
                {onConfirm && (
                    <Button onClick={onConfirm} variant="contained" color={confirmColor} autoFocus>
                        {confirmText}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};